import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NewGuestRoutingModule } from "./new-guest-routing.module";
import { AboutUsComponent } from "./AboutUs/about-us/about-us.component";
import { HomeComponent } from './home/home.component';
import { ReUsableModule } from "../../Components/re-usable.module";
import { AngularMaterialModule } from "../../DesignModules/angular-material.module";
import { PrimeNgModule } from "../../DesignModules/prime-ng.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ExtraDesignModule } from "../../DesignModules/extra-design.module";
import { ContactComponent } from './contact/contact.component';
@NgModule({
  declarations: [AboutUsComponent, HomeComponent, ContactComponent],
  imports: [
    CommonModule,
    NewGuestRoutingModule,
    ReUsableModule,
    AngularMaterialModule,
    PrimeNgModule,
    FormsModule,
    ReactiveFormsModule,
    ExtraDesignModule,
  ],
})
export class NewGuestModule {}
